import './App.css';
import Navbar from './components/Navbar';
import About from './components/About';
import Experience from './components/Experience';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <header>
        <Navbar/>
      </header>
      <main>
        <div className='main__container'>
            <section>
                <About/>
            </section>
            <section>
                <Experience/>
            </section>
        </div>
      </main>
      <footer>
        <Footer/>
      </footer>
    </div>
  );
}

export default App;
